var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.cert[_vm.keyP].name)+" ")]),_c('v-card-text',{staticClass:"px-5 pa-0 text-left"},[_vm._v(" "+_vm._s(_vm.cert[_vm.keyP].description)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }